import { KIZEN_PREFIX } from 'storage';

import { SessionStorage } from './SessionStorage';
export const SESSION_OAUTH_KEY = `${KIZEN_PREFIX}oauth`;
export const oauthSessionStorage = new SessionStorage(SESSION_OAUTH_KEY);
